module.exports = __webpack_public_path__ + "static/media/OneDayWorkshop.8e8f80f1.jpg";